export default __webpack_public_path__ + "static/media/object-account_darkGray2.25670276.svg";